module.exports = __webpack_public_path__ + "df7e05b2d55c1e5282ee81fa0a325f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/img/viega-logo.png
// module id = mm9V
// module chunks = 5